// @flow

import React, { Component } from 'react';
import {Icon} from 'react-fa';
import _ from 'lodash';
import $ from 'jquery';

import App from './App.jsx';
import Tree from './Tree.jsx';

import {takeDir, path_is_inside} from './utils.js';

import './css/Search.css';


// TODO: NUEVO BUSCADOR CON DIVERSOS FILTROS:
// texto
// rango de area cultivable (pequeño, mediano, grande, personalizado)
// rango de fecha
// año exacto
// tipo de servicio (adn_suelo, nutricheck_suelo, etc)
// especie
// número de puntos de muestreo



type T_SearchProps = {
  waiting : boolean,
  cls?    : string,
  hide?   : boolean,
  tree?   : Tree,
  height? : number,
  disabled: boolean,
  app     : App
};


type T_SearchState = {
  top       : number,
  search_str: string
}


export default class Search extends Component<T_SearchProps, T_SearchState> {
  begin_search: () => void;
  view_all    : () => void;
  keypress    : (ev: SyntheticKeyboardEvent<*>) => void;
  check_esc   : (ev: SyntheticKeyboardEvent<*>) => void;
  change      : (ev: SyntheticInputEvent<*>) => void;
  
  
  constructor(props: T_SearchProps) {
    super(props);
    
    this.state = {
      top       : -1,
      search_str: ''
    };
    
    this.begin_search = this.begin_search.bind(this);
    this.view_all     = this.view_all.bind(this);
    this.keypress     = this.keypress.bind(this);
    this.check_esc    = this.check_esc.bind(this);
    this.change       = this.change.bind(this);
  }
  
  
  
  set_position(): void {
    const bt_search = $('#sidebt_search');
    
    if (bt_search.length) {
      this.setState({top: bt_search.position().top + 17});
    }
  }
  
  
  
  componentDidMount(): void {
    this.set_position();
  }
  
  
  
  componentDidUpdate(prevProps: T_SearchProps): void {
    if (this.props.height != null && prevProps.height !== this.props.height) {
      this.set_position();
    }
  }
  
  
  
  get_pattern(): string {
    let pattern = this.state.search_str.trim();
    
    while (pattern.indexOf('  ') !== -1) {
      pattern = pattern.replace('  ', ' ');
    }
    
    return pattern.replace(/ /g, '_');
  }
  
  
  
  begin_search(): void {
    if (this.state.search_str !== '' && this.props.tree != null && ! this.props.disabled) {
      const {tree, app} = this.props;
      
      tree.setState({waiting: true}, () => {
        $.ajax({
          type    : 'POST',
          url     : `${app.remote}/db-find-dir/?session_id=${app.session()}`,
          dataType: 'json',
          async   : true,
          data    : {pattern: this.get_pattern()},
          success : (rs: Array<string>) => {
            const restrict_to = rs.filter(rdir => _.some(app.state.user.true_dirs, tdir => path_is_inside(rdir, tdir)));
            
            tree.setState({waiting: false, searched: true, restrict_to});
            
            if (app.dialog_report != null) {
              app.dialog_report.setState({restrict_to});
            }
          }
        });
      });
    }
  }
  
  
  
  view_all(): void {
    this.setState({search_str: ''});
    
    if (this.props.tree != null && ! this.props.disabled) {
      const {tree} = this.props;
      
      tree.setState({restrict_to: [], searched: false}, () => {
        tree.open_these(_.uniq(_.keys(this.props.app.map_ui.map.Shp_List).map(takeDir)));
      });
      
      if (this.props.app.dialog_report != null) {
        this.props.app.dialog_report.setState({restrict_to: []});
      }
    }
  }
  
  
  
  keypress(ev: SyntheticKeyboardEvent<*>): void {
    if (ev.charCode === 13) {
      this.begin_search();
    }
  }
  
  
  
  check_esc(ev: SyntheticKeyboardEvent<*>): void {
    if (ev.key === 'Escape') {
      this.view_all();
    }
  }
  
  
  
  change(ev: SyntheticInputEvent<*>): void {
    this.setState({search_str: ev.target.value});
  }
  
  
  
  render() {
    const disabled = {disabled: this.props.waiting || this.props.disabled},
          cls      = [this.props.cls || '', 'tree_search', this.props.hide ? 'hide' : ''].filter(_.identity).join(' ');
    
    let style = {};
    
    if (this.state.top !== -1) {
      style = {style: {top: this.state.top}};
    }
    
    return (
      <div className={cls} {...style}>
        <input {...disabled}
          type='text'
          placeholder='Predio o razón social…'
          value={this.state.search_str}
          onChange={this.change}
          onKeyPress={this.keypress}
          onKeyDown={this.check_esc}
          disabled={this.props.disabled}
        />

        <button onClick={this.begin_search} {...disabled}>
          Buscar
        </button>
        
        <button onClick={this.view_all} {...disabled}>
          <Icon name='undo' />
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Search.jsx